import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { formatInvoiceMoney } from "@common/helpers/nativeInvoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { InvoiceTemplateRow } from "../invoiceTemplates.types";
import styles from "./TotalCell.module.scss";

export const TotalCell = memo(function TotalCell({
    row,
}: CellContext<ViewTableFeatures, InvoiceTemplateRow, number | null>) {
    const template = row.original;
    const label =
        template.total == null
            ? "-"
            : formatInvoiceMoney(template.total, template.currency ?? "usd");

    return <ViewTableCell className={styles.cell}>{label}</ViewTableCell>;
});
